import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { useTranslation } from 'react-i18next';

import { useEmspBoEmspUserContext } from '../../emsp-bo-emsp-user.context';

export const EmspBoEmspUserLockDeleteFormStep1Controller =
  (): React.JSX.Element => {
    // CONTEXT /////////////////////////////////////////////////////////////////

    const { t } = useTranslation();
    const ocpiUser = useEmspBoEmspUserContext();

    // RENDER //////////////////////////////////////////////////////////////////

    return (
      <Text bold>
        {t('$.emsp-bo-emsp-user-lock-delete.step-1.confirm', {
          ocpiUserFirstName: ocpiUser.firstName,
          ocpiUserLastName: ocpiUser.lastName,
        })}
      </Text>
    );
  };
